import { format, isToday } from 'date-fns';

export default function formatLastSentAt(dateString) {
  const date = new Date(dateString);
  return format(date, isToday(date) ? 'hh:mm a' : 'MM/dd/yy');
}
